import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Opponent declined the battle" notification. Subject is the decliner
 * (a User, not the battle's discussion — that's deleted server-side, see
 * BattleDeclinedBlueprint), so this links to their profile instead.
 * content: { declinerName }
 */
export default class BattleDeclinedNotification extends Notification {
  icon() {
    return 'fas fa-door-closed';
  }
  href() {
    const user = this.attrs.notification.subject();
    return user ? app.route('user', {
      username: user.username()
    }) : '#';
  }
  content() {
    const user = this.attrs.notification.fromUser();
    const content = this.attrs.notification.content() || {};
    const name = user?.displayName() ?? content.declinerName ?? '?';
    return app.translator.trans('forumaker-arena.forum.notifications.battle_declined_text', {
      decliner: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/BattleDeclinedNotification', BattleDeclinedNotification);